"use client"

import React from "react"
import { useTranslations } from "next-intl"

import { getCategoryLinkByName } from "@/lib/link-utils/link-utils"
import { CategoryCard } from "@/components/storyblok/UbCategoryResults"

const max_subcategories = 5

export default function CategoryCardSubcategoryListClient({
  categoryCard,
  sbLocale,
}: {
  categoryCard: CategoryCard
  sbLocale: string
}) {
  const t = useTranslations("storefront")

  const subCategories = categoryCard.subCategories ?? []
  const hasSubCategories = subCategories.length > 0

  const showMoreLink = hasSubCategories && subCategories.length > max_subcategories

  // Die Liste auf die maximale Anzahl an Elementen kürzen
  const subcategoriesToDisplay = subCategories.slice(0, max_subcategories)

  return (
    <ul className="space-y-1">
      {hasSubCategories && (
        <>
          <div className={"hidden md:block"}>
            {subcategoriesToDisplay.map((category, index) => (
              <li key={category.id}>
                <a
                  href={getCategoryLinkByName(category.name, undefined, sbLocale)}
                  className="hover:text-underline text-sm font-bold text-primary hover:text-black"
                >
                  {category.name}
                </a>
              </li>
            ))}

            {showMoreLink && (
              <li key={categoryCard.name + "_more"}>
                <a href={categoryCard.link} className="text-sm font-bold text-black underline hover:text-primary">
                  {t("category.more")}
                </a>
              </li>
            )}
          </div>
          <div className={"block md:hidden"}>
            {subCategories.map((category, index) => (
              <li key={category.id}>
                <a
                  href={getCategoryLinkByName(category.name, undefined, sbLocale)}
                  className="hover:text-underline text-sm font-bold text-primary hover:text-black"
                >
                  {category.name}
                </a>
              </li>
            ))}
          </div>
        </>
      )}
    </ul>
  )
}
